export default __webpack_public_path__ + "images/0x236aa50979d5f3de3bd1eeb40e81137f22ab794b.png";